import { render, staticRenderFns } from "./OrderHistoryList.vue?vue&type=template&id=5342cd1e&scoped=true&"
import script from "./OrderHistoryList.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryList.vue?vue&type=style&index=0&id=5342cd1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5342cd1e",
  null
  
)

export default component.exports